import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { EmployeeListContainer } from '@/features/employees/containers/employee-list-container';
import { SubscriptionGate } from '@/lib/subscription';

export default function EmployeesPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('employees.title')}>
      <SubscriptionGate feature="employees">
        <EmployeeListContainer />
      </SubscriptionGate>
    </ListPageLayout>
  );
}
